import { shopifyGql, ShopifyGqlUserErrors } from '../shopify_client/graphql'
import { cartFragment } from './fragments'
import { ensureCartID } from './ensure_cart_id'
import { IBuildCheckoutAttributes, ICart, IMappedCustomAttributes } from '../shopify_client/types'

interface IAddVariantToCartArgs {
  cartID: string
  buildCheckoutAttributes: IBuildCheckoutAttributes
  variantID: string
  quantity: number
  customAttributes: IMappedCustomAttributes
}

export async function addVariantToCart(
  { cartID, buildCheckoutAttributes, variantID, quantity, customAttributes }: IAddVariantToCartArgs,
): Promise<ICart> {
  const ensuredCheckoutID: string = await ensureCartID({
    cartID,
    buildCheckoutAttributes,
  })

  const shopifyFormattedCustomAttributes = [
    { key: '_sourceURL', value: customAttributes._sourceURL },
    { key: '_ministryName', value: customAttributes._ministryName },
    { key: '_accountID', value: customAttributes._accountID },
  ]

  const cartLinesAddInput = {
    cartId: ensuredCheckoutID,
    lines: [
      {
        merchandiseId: variantID,
        quantity: quantity,
        attributes: shopifyFormattedCustomAttributes,
      }
    ]
  }

  const { data, errors } = await shopifyGql<ICartLinesAddData>(
    cartLinesAddMutation,
    cartLinesAddInput
  )

  if (errors.length > 0) { throw new AggregateError(errors, 'addVariantToCart.cartLinesAdd') }

  return data.cartLinesAdd.cart
}

const cartLinesAddMutation = `
mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
  cartLinesAdd(cartId: $cartId, lines: $lines) {
    cart {
      ...CartFragment
    }
    userErrors {
      field
      message
    }
  }
}
${cartFragment}
`

export interface ICartLinesAddData {
  cartLinesAdd: {
    cart: {
      __typename: 'Cart',
    } & ICart
  } & ShopifyGqlUserErrors
}
